import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import _ from "lodash";

import { _ClientBranchList } from "@/services/auth";
import {
  _fetchCandidateDropdownData,
  _fetchFieldData,
} from "@/services/clientCommon";
import {
  _fetchClientPublishBankHours,
  _updateClientPublishBankHours,
  _setNewDurationForUnfilledBankPublishContracts,
} from "@/services/clientnotification";
import {
  _getTopSearchResults,
  _updateQRCode,
  _updateTourGuide,
} from "@/services/header";
import {
  handleAPICatch,
  showSuccessToast,
  showErrorToast,
} from "@/utilities/utils";

import { updateUser } from "./clientprofile";
import { setSession } from "./session";
import { _localSet } from "../localStorage";
import { toastMessageText } from "../utilities/CommonText";

const initialState = {
  topSearch: "",
  topSearchResults: [],
  topSearchLoading: false,
  activePage: null,
  activeSubPage: null,
  clientBranches: [],
  filters: {
    search: "",
  },
  pagination: {
    currentPage: 1,
    totalPage: 1,
    isLastPage: false,
  },
  bankContractPublishHours: "00",
  oldBankContractPublishHours: "00",
  bankContractPublishHoursName: "",
  setbankContractPublishLoading: true,
  bankPublishContractDurationModal: false,
  setUpdateBankContractPublishHours: false,
  changeUnfilledBankPublishContractTimerModal: false,
  setNewDurationForUnfilledBankPublishContract: false,
  showClientBranchesModal: false,
  showTermsConditionModal: false,
  showQrCodeModal: false,
  showMarkAsUnsuitableReasonModal: false,
  clientQrCode: "",
  clientQrCodeKey: "",
  clientQrCodeUpdatedAt: "",
  isLoading: true,
  serverUrl: "",
  chatUrl: "",
  savedCreateJobDrafts: [],

  activeRoutesControls: [],

  showOurServiceModal: false,
  showClientBulkUpload: false,
  sideBarCollapsed: localStorage.getItem("sidebarCollapsed")
    ? JSON.parse(localStorage.getItem("sidebarCollapsed"))
    : false,
  mobileDrawerOpen: false,

  ///////
  candidateDropdownData: {},
  fieldData: {},
};

export const fetchCandidateDropdownData = createAsyncThunk(
  "clientCommon/fetchCandidateDropdownData",
  async (data, { dispatch }) => {
    let callback = data && data.callback ? data?.callback : null;
    if (data && data.callback) {
      delete data.callback;
    }
    const response = _fetchCandidateDropdownData(data);
    response
      .then((res) => {
        const dropdownData = res.data || {};
        // const {
        //   data: { dropdown_data },
        // } = res;
        callback && callback(dropdownData);
        dispatch(updateCandidateDropdownData(dropdownData));
      })
      .catch((error) => {
        console.log("fetchCandidateDropdownData error:", error);
        handleAPICatch(error);
      });
  },
);

export const fetchFieldData = createAsyncThunk(
  "clientCommon/fetchFieldData",
  async (data, { dispatch }) => {
    let callback = data.callback ? data.callback : null;
    if (data.callback) {
      delete data.callback;
    }
    const response = _fetchFieldData(data);
    response
      .then((res) => {
        const {
          data: { field_data },
        } = res;
        if (callback && typeof callback === "function") {
          callback(field_data);
        } else {
          let _data = {
            [_key]: field_data,
          };
          dispatch(updateFieldData(_data));
        }
      })
      .catch((error) => {
        handleAPICatch(error);
      });
  },
);

export const fetchTopSearchResults = createAsyncThunk(
  "clientCommon/fetchTopSearchResults",
  async (data, thunkAPI) => {
    const response = _getTopSearchResults(data);
    response
      .then((res) => {
        const {
          data: { search_result },
        } = res;
        thunkAPI.dispatch(updateTopSearchResults(search_result));
      })
      .catch((error) => {})
      .finally(() => {
        thunkAPI.dispatch(toggleTopSearchLoading(false));
      });
  },
);

export const fetchClientBranches = createAsyncThunk(
  "clientCommon/fetchClientBranches",
  async (data, { getState, dispatch }) => {
    let paginationData = getState().clientCommon.pagination;
    let filtersData = getState().clientCommon.filters;
    if (_.isEmpty(data)) {
      data = {
        ...filtersData,
      };
    }
    const _data = {
      ...data,
    };
    const response = _ClientBranchList(_data);
    response
      .then((res) => {
        const {
          data: { client_branches_list },
        } = res;
        dispatch(updateClientBranches(client_branches_list));
      })
      .catch((error) => {
        handleAPICatch(error);
      })
      .finally(() => {
        dispatch(setClientBranchesLoading(false));
      });
  },
);

export const updateQRCode = createAsyncThunk(
  "clientCommon/updateQRCode",
  async (data, thunkAPI) => {
    const response = _updateQRCode();
    response
      .then((res) => {
        const {
          data: { qr_code, newQRCode, qr_code_updated_at },
        } = res;
        thunkAPI.dispatch(
          updateClientQrCode({
            qr_code: newQRCode,
            qr_code_key: qr_code,
            qr_code_updated_at,
          }),
        );
        thunkAPI?.dispatch(
          setSession({
            qr_code_key: qr_code,
          }),
        );
      })
      .catch((error) => {
        // handleAPICatch(error);
      })
      .finally(() => {
        //
      });
  },
);

export const fetchClientPublishBankContract = createAsyncThunk(
  "clientCommon/fetchClientPublishBankContract",
  async (data, { dispatch }) => {
    // dispatch(setsetbankContractPublishLoading(true));
    const response = _fetchClientPublishBankHours();
    response
      .then((res) => {
        const {
          data: {
            settings: [{ setting_value, setting_name } = {}],
          },
        } = res;
        dispatch(updateBankContractPublishHoursName(setting_name));
        dispatch(
          updateBankContractPublishHours(
            setting_value == "" ? "00" : setting_value,
          ),
        );
        dispatch(
          oldBankContractPublishHours(
            setting_value == "" ? "00" : setting_value,
          ),
        );
      })
      .catch((error) => {
        handleAPICatch(error);
      })
      .finally(() => {
        //
        setTimeout(() => {
          dispatch(setsetbankContractPublishLoading(false));
        }, 10);
      });
  },
);

export const updateClientPublishBankContractDuration = createAsyncThunk(
  "clientCommon/updateClientPublishBankContractDuration",
  async (data, { dispatch }) => {
    const { bankContractPublishHours, loading, setLoading } = data;
    // return;
    const updateData = {
      settingName: "bank_contract_publish_hours",
      settingValue: bankContractPublishHours,
    };
    if (loading) return;
    setLoading(true);
    const response = _updateClientPublishBankHours(updateData);
    response
      .then((res) => {
        // return;
        const {
          data: { message },
        } = res;
        showSuccessToast(message);
        dispatch(toggleBankPublishContractDurationModal(false));
        dispatch(oldBankContractPublishHours(bankContractPublishHours));
      })
      .catch((error) => {
        handleAPICatch(error);
      })
      .finally(() => {
        //
        setLoading(false);
      });
  },
);

export const setNewDurationForUnfilledBankPublishBankContract =
  createAsyncThunk(
    "clientCommon/setNewDurationForUnfilledBankPublishBankContract",
    async (data, { dispatch, getState }) => {
      const { contract_ids, timer_hours, loading, setLoading, callback } = data;
      const updateData = {
        contract_ids: contract_ids,
        timer_hours: timer_hours,
      };
      if (loading) return;
      setLoading(true);
      const response =
        _setNewDurationForUnfilledBankPublishContracts(updateData);
      response
        .then((res) => {
          const {
            data: { message },
          } = res;
          callback && callback();
          showSuccessToast(message);
          dispatch(
            toggleSetNewDurationForUnfilledBankPublishContractModal(false),
          );
        })
        .catch((error) => {
          const { data } = error;
          callback && callback();
          if (data?.error == "No record updated.") {
            showErrorToast(toastMessageText?.alreadySetTimeForBankContract);
            return;
          }
          handleAPICatch(error);
        })
        .finally(() => {
          setLoading(false);
        });
    },
  );

export const updateUserGuideAppconnectTour = createAsyncThunk(
  "clientCommon/updateUserGuideAppconnectTour",
  async (data, { dispatch, getState }) => {
    const response = _updateTourGuide(data);
    response
      .then((res) => {
        // return;
        const {
          data: { message },
        } = res;
        // showSuccessToast(message);
        dispatch(
          updateUser({
            is_view_user_tour: 1,
          }),
        );
        // dispatch(toggleSetNewDurationForUnfilledBankPublishContractModal(false));
        // callback && callback();
      })
      .catch((error) => {
        handleAPICatch(error);
      })
      .finally(() => {
        //
        setLoading(false);
      });
  },
);

const clientCommonSlice = createSlice({
  name: "clientCommon",
  initialState,
  reducers: {
    updateTopSearch: (state, action) => {
      state.topSearch = action.payload;
    },
    updateTopSearchResults: (state, action) => {
      state.topSearchResults = action.payload;
    },
    setsetbankContractPublishLoading: (state, action) => {
      state.setbankContractPublishLoading = action.payload;
    },

    toggleTopSearchLoading: (state, action) => {
      state.topSearchLoading = action.payload;
    },
    updateactivePages: (state, action) => {
      let callback = action.payload.callback ? action.payload.callback : null;
      if (action.payload.callback) {
        delete action.payload.callback;
      }
      state.activePage = action.payload.activePage;
      state.activeSubPage = action.payload.activeSubPage;
      setTimeout(() => {
        callback && callback();
      }, 50);
    },
    toggleTermsConditionModal: (state, action) => {
      state.showTermsConditionModal = action.payload;
    },
    toggleQrCodeModal: (state, action) => {
      state.showQrCodeModal = action.payload;
    },
    updateClientQrCode: (state, action) => {
      const { qr_code, qr_code_key, qr_code_updated_at } = action.payload;
      state.clientQrCode = qr_code;
      state.clientQrCodeKey = qr_code_key;
      state.clientQrCodeUpdatedAt = qr_code_updated_at;
    },
    updateClientBranches: (state, action) => {
      state.clientBranches = action.payload;
    },
    updateURLs: (state, action) => {
      state.serverUrl = action.payload.serverUrl;
      state.chatUrl = action.payload.chatUrl;
    },
    savejobAsDraft: (state, action) => {
      let createJobObj = action.payload;
      if (createJobObj.length) {
        createJobObj.map((item) => {
          state.savedCreateJobDrafts.push(item);
        });
      }
    },
    toggleOurServiceModal: (state, action) => {
      state.showOurServiceModal = action.payload;
    },
    toggleClientBranchesModal: (state, action) => {
      state.showClientBranchesModal = action.payload;
    },
    toggleMarkAsUnsuitableReasonModal: (state, action) => {
      state.showMarkAsUnsuitableReasonModal = action.payload;
    },
    setClientBranchesLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    updatePagination: (state, action) => {
      state.pagination = action.payload;
    },
    updateBankContractPublishHours: (state, action) => {
      state.bankContractPublishHours = action.payload;
    },
    oldBankContractPublishHours: (state, action) => {
      state.oldBankContractPublishHours = action.payload;
    },
    updateBankContractPublishHoursName: (state, action) => {
      state.bankContractPublishHoursName = action.payload;
    },
    updateFilters: (state, action) => {
      if (_.isEmpty(action.payload)) {
        state.filters = {
          search: state.filters.search,
          ...initialState.filters,
        };
        return;
      } else {
        if (action.payload.reset) {
          state.filters = initialState.filters;
        } else {
          state.filters = { ...state.filters, ...action.payload };
        }
      }
    },
    toggleBankPublishContractDurationModal: (state, action) => {
      state.bankPublishContractDurationModal = action.payload;
    },
    toggleChangeUnfilledBankPublishContractTimerModal: (state, action) => {
      state.changeUnfilledBankPublishContractTimerModal = action.payload;
    },

    toggleSetNewDurationForUnfilledBankPublishContractModal: (
      state,
      action,
    ) => {
      state.setNewDurationForUnfilledBankPublishContract = action.payload;
    },

    toggleClientBulkUploadModal: (state, action) => {
      state.showClientBulkUpload = action.payload;
    },

    toggleSidebarsideBarCollapsed: (state, action) => {
      _localSet("sidebarCollapsed", action.payload);
      state.sideBarCollapsed = action.payload;
    },

    toggleMobileDrawer: (state, action) => {
      state.mobileDrawerOpen = action.payload;
    },

    updateCandidateDropdownData: (state, action) => {
      state.candidateDropdownData = {
        ...state.candidateDropdownData,
        ...action.payload,
      };
    },
    updateFieldData: (state, action) => {
      state.fieldData = {
        ...state.fieldData,
        ...action.payload,
      };
    },
  },
});

export const {
  updateTopSearch,
  updateTopSearchResults,
  toggleTopSearchLoading,
  updateactivePages,
  toggleTermsConditionModal,
  setsetbankContractPublishLoading,
  toggleQrCodeModal,
  toggleMarkAsUnsuitableReasonModal,
  updateClientQrCode,
  updateClientBranches,
  updateURLs,
  savejobAsDraft,
  toggleOurServiceModal,
  oldBankContractPublishHours,
  toggleClientBranchesModal,
  setClientBranchesLoading,
  updatePagination,
  updateFilters,
  updateBankContractPublishHours,
  updateBankContractPublishHoursName,
  toggleBankPublishContractDurationModal,
  toggleChangeUnfilledBankPublishContractTimerModal,
  toggleSetNewDurationForUnfilledBankPublishContractModal,
  toggleClientBulkUploadModal,
  toggleSidebarsideBarCollapsed,
  toggleMobileDrawer,
  updateCandidateDropdownData,
  updateFieldData,
} = clientCommonSlice.actions;

export default clientCommonSlice.reducer;
